<template>
    <v-col @click="showVideoDialog" :cols="cols" :md="colsMd" class="exercise-img"
           :style="{ backgroundImage: `url('${img}')` }">
        <watch-video-dialog v-if="video" :thumb="img" :video="video" :is-second-dialog="isSecondDialog"
                            ref="watchVideo"/>
    </v-col>
</template>

<script>
import WatchVideoDialog from "@/components/common/routines/WatchVideoDialog";

export default {
    name: "ExerciseImgVideo",
    components: {WatchVideoDialog},
    props: {
        cols: {
            type: [String, Number],
            default: 2,
        },
        colsMd: {
            type: [String, Number],
            default: 2,
        },
        img: {
            type: String,
            default: require(`@/assets/img/logo.png`)
        },
        video: {
            type: String,
            default: null
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        showVideoDialog() {
            const vm = this
            if (!vm.video || vm.readonly) return
            vm.$refs.watchVideo.show()
        },
    },
}
</script>

<style scoped>

.exercise-img {
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px 0 0 4px;
    background-color: rgba(1, 55, 46, 0.05);
}

</style>